import pdf_default from 'assets/pdf_thumbnail_26012023.png';
import { createBlock } from 'factories/block';
import { createEditableBtn } from './editableBtn';

// defaults to true
// useBackgroundControls: useBackgroundControls !== undefined ? useBackgroundControls : true,

export type MediaBlock = {
  child?: number;
  src?: string;
  name?: string;
  style?: { [key: string]: number | string };
  removeTypes?: string[];
  forceInclude?: string[];
  useBackgroundControls?: boolean;
  bulletColor?: string;
  fit?: string;
  imgPlaceholderIndex?: number;
  isAdditionalMedia?: boolean;
  type?: string;
};

const createTranscriptBlock = useBackgroundControls => {
  return createBlock(
    'Transcript',
    [
      createBlock('Text', [], {
        props: {
          useBackgroundControls:
            useBackgroundControls !== undefined ? useBackgroundControls : true,
        },
      }),
      createEditableBtn({ label: 'Continue' }),
    ],
    {}
  );
};

export const createMediaBlock = (props: MediaBlock) => {
  const {
    child = 1,
    src = undefined,
    removeTypes = [],
    forceInclude = [],
    useBackgroundControls,
    bulletColor,
    fit,
    imgPlaceholderIndex,
    isAdditionalMedia,
  } = props;

  // if is an image
  // image specific props;

  return createBlock(
    'Media',
    [
      createBlock('Text', [], {
        props: {
          useBackgroundControls:
            useBackgroundControls !== undefined ? useBackgroundControls : true,
          bulletColor,
        },
      }),

      createBlock('Image', [], {
        props: {
          src: child === 1 && src ? src : undefined,
          fit,
        },
      }),

      createBlock('Video', [createTranscriptBlock(useBackgroundControls)], {
        props: {
          src: child === 2 && src ? src : 'https://vimeo.com/512335672',
        },
      }),
      createBlock('SVG', [], {
        props: {
          src: child === 3 && src,
        },
      }),
      createBlock('Embed', [], {
        props: {
          src: child === 4 && src,
        },
      }),
      createBlock('Audio', [createTranscriptBlock(useBackgroundControls)], {
        props: {
          src:
            child === 5 && src
              ? src
              : 'https://www.bensound.com/bensound-music/bensound-dubstep.mp3',
        },
      }),
      createBlock(
        'PDF',
        [
          createBlock(
            'OpenPDF',
            [
              createBlock('Text', [], {
                props: {},
              }),
            ],
            {
              props: {
                src: pdf_default,
                fit: 'cover',
              },
            }
          ),
        ],
        {
          props: {
            src: child === 6 && src ? src : '',
            displayInline: false,
          },
        }
      ),
    ],
    {
      props: {
        name: props.name || '',
        style: props.style || {},
        child,
        removeTypes,
        forceInclude,
        src,
        imgPlaceholderIndex,
        isAdditionalMedia,
      },
      meta: {
        subType: 'Media',
      },
    }
  );
};
